// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tags[data-v-684fd4c6] {\n  background-color: #016bff0d;\n  color: #016bff;\n}\n.borderMainClientProfile[data-v-684fd4c6] {\n  border-bottom: 1px solid #f9f9f9;\n}\n.minWContent[data-v-684fd4c6] {\n  min-width: 240px;\n}\n", ""]);
// Exports
module.exports = exports;
